"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainProp = void 0;
const monet_1 = require("monet");
function chainProp(key, x) {
    const fn = (_key, _x) => _x
        ? monet_1.Maybe.fromNull(_x[_key])
            // @ts-expect-error
            .chain(val => monet_1.Maybe.isInstance(val) ? (0, monet_1.Just)(val) : (0, monet_1.None)())
            // @ts-expect-error
            .chain((I) => I)
        : (0, monet_1.None)();
    return arguments.length === 2
        ? fn(key, x)
        : (y) => fn(key, y);
}
exports.chainProp = chainProp;
//# sourceMappingURL=chainProp.js.map